import React from 'react';

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUsers, IconCalendar, IconMap2, IconMapPins, IconFlag3 } from '@tabler/icons';

// constant
const icons = {
    IconUsers,
    IconCalendar,
    IconMap2,
    IconMapPins,
    IconFlag3
};

// ===========================|| APPLICATION MENU ITEMS ||=========================== //

const pmpApplication = {
    id: 'application',
    title: <FormattedMessage id="application" />,
    type: 'group',
    children: [
        {
            id: 'sankalp',
            title: <FormattedMessage id="menu.sankalp" />,
            type: 'collapse',
            icon: icons.IconMapPins,
            url: '/sankalp/ahawal',
            children: [
                {
                    id: 'add-sankalp',
                    title: <FormattedMessage id="menu.sankalp.addmultisankalp" />,
                    type: 'item',
                    url: '/sankalp/addmultisankalp',
                    breadcrumbs: false
                },
                {
                    id: 'sankalp-list',
                    title: <FormattedMessage id="menu.sankalp.list" />,
                    type: 'item',
                    url: '/sankalp/list',
                    breadcrumbs: false
                },
                {
                    id: 'sankalp-ahawal',
                    title: <FormattedMessage id="menu.sankalp.ahawal" />,
                    type: 'item',
                    url: '/sankalp/ahawal',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'sadyashtiti',
            title: <FormattedMessage id="menu.sadyashtiti_label" />,
            type: 'collapse',
            icon: icons.IconFlag3,
            url: '/sadyashiti/ahawal',
            children: [
                {
                    id: 'sadyasthiti-list',
                    title: <FormattedMessage id="menu.sadyashtiti_view_list" />,
                    type: 'item',
                    url: '/sadyashiti/list',
                    breadcrumbs: false
                },
                {
                    id: 'sadyasthiti-active-suchi',
                    title: <FormattedMessage id="menu.sadyashtiti_active_suchi" />,
                    type: 'item',
                    url: '/sadyashiti/active-suchi',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'bhaugolik-rachana',
            title: <FormattedMessage id="bhaugolik-rachana" />,
            type: 'collapse',
            icon: icons.IconMap2,
            children: [
                {
                    id: 'system-users-list',
                    title: <FormattedMessage id="bhaugolik-rachana-view" />,
                    type: 'item',
                    url: '/geo/tree',
                    breadcrumbs: false
                },
                {
                    id: 'edit-system-user',
                    title: <FormattedMessage id="bhaugolik-rachana-edit" />,
                    type: 'item',
                    url: '/geo/tree/edit',
                    breadcrumbs: false
                },
                {
                    id: 'sevavasti-list',
                    title: <FormattedMessage id="menu.seva-vasti.list" />,
                    type: 'item',
                    url: '/seva-vasti/list',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'system-users',
            title: <FormattedMessage id="system-users" />,
            type: 'collapse',
            icon: icons.IconUsers,
            children: [
                {
                    id: 'add-system-user',
                    title: <FormattedMessage id="add-system-user" />,
                    type: 'item',
                    url: '/user/add',
                    breadcrumbs: false
                },
                {
                    id: 'system-users-list',
                    title: <FormattedMessage id="system-users-list" />,
                    type: 'item',
                    url: '/user/list',
                    breadcrumbs: false
                },
                {
                    id: 'unapproved-users-list',
                    title: <FormattedMessage id="menu.approve" />,
                    type: 'item',
                    url: '/user/unapproved',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'utsav-sankhya-nondani',
            title: <FormattedMessage id="menu.utsav-sankhya" />,
            type: 'collapse',
            icon: icons.IconCalendar,
            children: [
                {
                    id: 'makarsankrant',
                    title: <FormattedMessage id="menu.utsav-sankhya.makarsankrant" />,
                    type: 'item',
                    url: '/utsav/makarsankrant-nondani',
                    breadcrumbs: false
                },
                {
                    id: 'varshpratipada',
                    title: <FormattedMessage id="menu.utsav-sankhya.varshpratipada" />,
                    type: 'item',
                    url: '/utsav/varshpratipada-nondani',
                    breadcrumbs: false
                },
                {
                    id: 'hindusamrajyadin',
                    title: <FormattedMessage id="menu.utsav-sankhya.hindusamrajyadin" />,
                    type: 'item',
                    url: '/utsav/hindusamrajyadin-nondani',
                    breadcrumbs: false
                },
                {
                    id: 'gurupujan',
                    title: <FormattedMessage id="menu.utsav-sankhya.gurupujan" />,
                    type: 'item',
                    url: '/utsav/gurupujan-nondani',
                    breadcrumbs: false
                },
                {
                    id: 'rakshabandhan',
                    title: <FormattedMessage id="menu.utsav-sankhya.rakshabandhan" />,
                    type: 'item',
                    url: '/utsav/rakshabandhan-nondani',
                    breadcrumbs: false
                },
                {
                    id: 'vijayadashami',
                    title: <FormattedMessage id="menu.utsav-sankhya.vijayadashami" />,
                    type: 'item',
                    url: '/utsav/vijayadashami-nondani',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'utsav-sankhya-vrutta',
            title: <FormattedMessage id="menu.utsav-vrutta" />,
            type: 'collapse',
            icon: icons.IconCalendar,
            children: [
                {
                    id: 'makarsankrant',
                    title: <FormattedMessage id="menu.utsav-sankhya.makarsankrant" />,
                    type: 'item',
                    url: '/utsav/makarsankrant-vrutta',
                    breadcrumbs: false
                },
                {
                    id: 'varshpratipada',
                    title: <FormattedMessage id="menu.utsav-sankhya.varshpratipada" />,
                    type: 'item',
                    url: '/utsav/varshpratipada-vrutta',
                    breadcrumbs: false
                },
                {
                    id: 'hindusamrajyadin',
                    title: <FormattedMessage id="menu.utsav-sankhya.hindusamrajyadin" />,
                    type: 'item',
                    url: '/utsav/hindusamrajyadin-vrutta',
                    breadcrumbs: false
                },
                {
                    id: 'gurupujan',
                    title: <FormattedMessage id="menu.utsav-sankhya.gurupujan" />,
                    type: 'item',
                    url: '/utsav/gurupujan-vrutta',
                    breadcrumbs: false
                },
                {
                    id: 'rakshabandhan',
                    title: <FormattedMessage id="menu.utsav-sankhya.rakshabandhan" />,
                    type: 'item',
                    url: '/utsav/rakshabandhan-vrutta',
                    breadcrumbs: false
                },
                {
                    id: 'vijayadashami',
                    title: <FormattedMessage id="menu.utsav-sankhya.vijayadashami" />,
                    type: 'item',
                    url: '/utsav/vijayadashami-vrutta',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default pmpApplication;
